"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _autoBind = _interopRequireDefault(require("auto-bind"));

var _marshaler = _interopRequireDefault(require("../../util/marshaler"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var DeviceRepository = /*#__PURE__*/function () {
  function DeviceRepository(registry) {
    (0, _classCallCheck2["default"])(this, DeviceRepository);
    this._api = registry;
    (0, _autoBind["default"])(this);
  } // Brands retrieval.


  (0, _createClass2["default"])(DeviceRepository, [{
    key: "listBrands",
    value: function () {
      var _listBrands = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(appId) {
        var params,
            selector,
            result,
            _args = arguments;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                params = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
                selector = _args.length > 2 && _args[2] !== undefined ? _args[2] : [];
                _context.next = 4;
                return this._api.ListBrands({
                  routeParams: {
                    'application_ids.application_id': appId
                  }
                }, _objectSpread(_objectSpread({}, params), _marshaler["default"].selectorToFieldMask(selector)));

              case 4:
                result = _context.sent;
                return _context.abrupt("return", _marshaler["default"].payloadListResponse('brands', result));

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function listBrands(_x) {
        return _listBrands.apply(this, arguments);
      }

      return listBrands;
    }()
  }, {
    key: "getBrand",
    value: function () {
      var _getBrand = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(appId, brandId) {
        var selector,
            result,
            _args2 = arguments;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                selector = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : [];
                _context2.next = 3;
                return this._api.GetBrand({
                  routeParams: {
                    'application_ids.application_id': appId,
                    brand_id: brandId
                  }
                }, _objectSpread({}, _marshaler["default"].selectorToFieldMask(selector)));

              case 3:
                result = _context2.sent;
                return _context2.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getBrand(_x2, _x3) {
        return _getBrand.apply(this, arguments);
      }

      return getBrand;
    }() // Models retrieval.

  }, {
    key: "listModels",
    value: function () {
      var _listModels = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(appId, brandId) {
        var params,
            selector,
            result,
            _args3 = arguments;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                params = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : {};
                selector = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : [];
                _context3.next = 4;
                return this._api.ListModels({
                  routeParams: {
                    'application_ids.application_id': appId,
                    brand_id: brandId
                  }
                }, _objectSpread(_objectSpread({}, params), _marshaler["default"].selectorToFieldMask(selector)));

              case 4:
                result = _context3.sent;
                return _context3.abrupt("return", _marshaler["default"].payloadListResponse('models', result));

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function listModels(_x4, _x5) {
        return _listModels.apply(this, arguments);
      }

      return listModels;
    }()
  }, {
    key: "getModel",
    value: function () {
      var _getModel = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(appId, brandId, modelId) {
        var selector,
            result,
            _args4 = arguments;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                selector = _args4.length > 3 && _args4[3] !== undefined ? _args4[3] : [];
                _context4.next = 3;
                return this._api.GetModel({
                  routeParams: {
                    'application_ids.application_id': appId,
                    brand_id: brandId,
                    model_id: modelId
                  }
                }, _objectSpread({}, _marshaler["default"].selectorToFieldMask(selector)));

              case 3:
                result = _context4.sent;
                return _context4.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getModel(_x6, _x7, _x8) {
        return _getModel.apply(this, arguments);
      }

      return getModel;
    }() // Templates retrieval.

  }, {
    key: "getTemplate",
    value: function () {
      var _getTemplate = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(appId, version) {
        var result;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this._api.GetTemplate({
                  routeParams: {
                    'application_ids.application_id': appId,
                    'version_ids.brand_id': version.brand_id,
                    'version_ids.model_id': version.model_id,
                    'version_ids.firmware_version': version.firmware_version,
                    'version_ids.band_id': version.band_id
                  }
                });

              case 2:
                result = _context5.sent;
                return _context5.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getTemplate(_x9, _x10) {
        return _getTemplate.apply(this, arguments);
      }

      return getTemplate;
    }() // Formatters retrieval.

  }, {
    key: "getUplinkDecoder",
    value: function () {
      var _getUplinkDecoder = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(appId, version) {
        var result;
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this._api.GetUplinkDecoder({
                  routeParams: {
                    'application_ids.application_id': appId,
                    'version_ids.brand_id': version.brand_id,
                    'version_ids.model_id': version.model_id,
                    'version_ids.firmware_version': version.firmware_version,
                    'version_ids.band_id': version.band_id
                  }
                });

              case 2:
                result = _context6.sent;
                return _context6.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function getUplinkDecoder(_x11, _x12) {
        return _getUplinkDecoder.apply(this, arguments);
      }

      return getUplinkDecoder;
    }()
  }, {
    key: "getDownlinkDecoder",
    value: function () {
      var _getDownlinkDecoder = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(appId, version) {
        var result;
        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this._api.GetDownlinkDecoder({
                  routeParams: {
                    'application_ids.application_id': appId,
                    'version_ids.brand_id': version.brand_id,
                    'version_ids.model_id': version.model_id,
                    'version_ids.firmware_version': version.firmware_version,
                    'version_ids.band_id': version.band_id
                  }
                });

              case 2:
                result = _context7.sent;
                return _context7.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function getDownlinkDecoder(_x13, _x14) {
        return _getDownlinkDecoder.apply(this, arguments);
      }

      return getDownlinkDecoder;
    }()
  }, {
    key: "getDownlinkEncoder",
    value: function () {
      var _getDownlinkEncoder = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8(appId, version) {
        var result;
        return _regenerator["default"].wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this._api.GetDownlinkEncoder({
                  routeParams: {
                    'application_ids.application_id': appId,
                    'version_ids.brand_id': version.brand_id,
                    'version_ids.model_id': version.model_id,
                    'version_ids.firmware_version': version.firmware_version,
                    'version_ids.band_id': version.band_id
                  }
                });

              case 2:
                result = _context8.sent;
                return _context8.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function getDownlinkEncoder(_x15, _x16) {
        return _getDownlinkEncoder.apply(this, arguments);
      }

      return getDownlinkEncoder;
    }()
  }]);
  return DeviceRepository;
}();

var _default = DeviceRepository;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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